<template>
  <div class="mx-auto" style="max-width: 1000px;">
      <v-card>
          <v-card-title>{{ feedback.title }}</v-card-title>
          <v-card-text>
            <row-line :label="$t('Type')">{{ __attr(feedback.type) }}</row-line>
            <row-line :label="$t('Content')">
                <div v-html="feedback.content"/>
            </row-line>
            <row-line :label="$t('Documents')">
                <div>
                    <single-file-item v-for="file in files"
                                        :key="`file-${file.id}`"
                                        :file="file"/>
                </div>
            </row-line>
            <row-line :label="$t('Sender')">{{ sender.name }}</row-line>
            <row-line :label="$t('Created at')"> {{ utcToLocalDateTimeLess(feedback.created_at) }} </row-line>
          </v-card-text>
      </v-card>
      <div class="text-center my-5">
        <v-btn color="secondary" @click="__back('feedback.index', $event)">
            {{ $t('Back')}}
        </v-btn>
    </div>
  </div>
</template>

<script>
import RowLine from '@components/RowLine'
import SingleFileItem from '@/components/SingleFileItem'
import { get, call } from 'vuex-pathify'
import { utcToLocalDateTimeLess } from '@utils'

export default {
  name: 'ProjectCreate',
  components: {
    RowLine, SingleFileItem
  },
  computed: {
    feedback: get('feedback/feedback'),
    files: get('feedback/files'),
    sender: get('feedback/sender'),
    id() {
      return this.$route.params.id
    }
  },
  mounted() {
    this.show({
      id: this.id,
      params: {
        _include: ['user', 'files']
      }
    })
  },
  methods: {
    show: call('feedback/show'),
    utcToLocalDateTimeLess
  }
}
</script>
